<div class="modal-dialog" [attr.role]="'document'">
	<div class="modal-content">

    <p class="col-sm-2 col-sm-offset-10 generic-close-modal-btn">
			<button class="btn btn-default-reverse btn-block btn-sm"
				[attr.data-dismiss]="'modal'" type="button">Chiudi</button>
		</p>
    <div class="titleblock" style="margin-bottom: 25px;" >
      <h3 class="title1level">Nuovo Protocollo</h3>
    </div>
    <app-protocol-fascicolo-insert [isDocumentInserted]="true" [documento]="documento" [listaDocumenti]="listaDocumenti" #protocol (onInsert)="onInsert($event)"></app-protocol-fascicolo-insert>
  </div>
</div>
